export default function checkVersion (osVersion, iosVersion) {
  var userAgent = navigator.userAgent;
  var userAgentTemp = userAgent.substring(
    userAgent.indexOf("yugeyiliao"),
    userAgent.length
  );
  var version;
  if (userAgent.indexOf("Android") >= 0) {
    version = userAgentTemp.substring(
      userAgentTemp.indexOf("_") + 1,
      userAgentTemp.indexOf("_", userAgentTemp.indexOf("_") + 1)
    );
    version = version.replace(/\./g, "");
    if (version >= osVersion) {
      return true;
    }
  }
  if (userAgent.indexOf("iPhone") >= 0) {
    version = userAgentTemp
      .substring(userAgentTemp.indexOf("_") + 1, userAgentTemp.length)
      .replace(/\./g, "");
    if (version >= iosVersion) {
      return true;
    }
  }
  return false;
}
